/* tslint:disable */

import { Log } from 'ng2-logger';
import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import { Common } from '../../core/common';
import Translator from '../../core/i18n';
import * as Actions from '../../store/actions/coursePage';
import { IAction, IAppState } from '../../models/action/core';
import { ActivityTypeEnums } from '../../models/enums/ActivityType';
import { IActivityFilters } from '../../models/action/coursePage';
import { CourseContentMenuType } from '../../models/enums/CourseContentMenuType';
import { SelectNoneAsync } from '../input/select/main';
import { CoursePageService } from '../../api/course-page-service';
import { IActivityCard } from '../../models/components/activity-card';
import { ILessonPageClassInformation } from '../../models/pages/coursePage';
import { ICourseContentWeekActivitesBody } from '../../models/components/course-content-weekactivities';
import { Redirect } from 'react-router-dom';
import { CourseDefaultViewType } from '../../models/enums/CourseDefaultViewType';
import ReactGA from 'react-ga4';

const _logger = Log.create('ActivityCardMain.tsx');
const T = Translator.create();
let _common: Common;
const coursePageService = new CoursePageService();
let active = 0;
const _lodash = require('lodash');

interface IActivityFiltersProps {
    dispatch?: any;
    coursePageClassId?: string;
    coursePageActivityId?: string;
    activityIdAfterAdd?: string;
    courseContentMenuType?: CourseContentMenuType;
    weekOrUnitId?: string | null;
    courseContentTermWeeks?: Array<{ notWeekly: boolean, notWeeklyName: string | null, termId: string | null, termWeekId: string | null, week: number | null, endDate: Date | null, startDate: Date | null, itemGuid: string, genaralActivity: boolean, status: number }> | null;
    courseContentWeeksActivities?: Array<ICourseContentWeekActivitesBody>;
    coursePageClassInformation?: ILessonPageClassInformation | null;
    sort?: string | null;
    courseDefaultView?: CourseDefaultViewType | null;
    loaded?: boolean | null;
    onClose: any;
    updateFilterData: any;
    filterData: any;
}

interface IActivityFiltersState {
    filters: IActivityFilters;
    sorting: string;
    isLoading: boolean;
    isFirstLoad: boolean;
    statusFilter: number;
    redirectMessagesPage: boolean;
    selectedTeacherId: string;
    weeklyTerm?: boolean | null;
    nonWeeklyCourse?: boolean | null;
    isCheckboxDisabled?: boolean;
}



class FilterModal extends React.Component<IActivityFiltersProps, IActivityFiltersState> {
    delayTimer: any;
    delayTimerCheckbox: any;

    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            filters: {
                searchedText: '',
                selectedActivityTypes: [],
                sort: this.props.sort ?? '-',
                hasFilter: false,
                GetOnlyPassiveList: false,
            },
            sorting: this.props.sort ?? '-',
            isLoading: false,
            isFirstLoad: true,
            statusFilter: -1,
            redirectMessagesPage: false,
            selectedTeacherId: '',
            weeklyTerm: this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length > 1,
            nonWeeklyCourse: this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length === 1,
            isCheckboxDisabled: false
        };
        this.onFilter.bind(this);
        this.inputOnChange.bind(this);


    }

    componentDidMount() {


    }
    componentDidUpdate(prevProps: IActivityFiltersProps, prevState: any) {

        if (this.props.activityIdAfterAdd !== prevProps.activityIdAfterAdd && this.props.activityIdAfterAdd) {
            const _filters = {
                searchedText: '',
                selectedActivityTypes: [],
                sort: this.props.sort ?? '-',
                hasFilter: false,
                GetOnlyPassiveList: false,
            };

            this.setState({ filters: _filters, sorting: this.props.sort ?? '-' });
        }

        if (this.props.courseContentTermWeeks !== prevProps.courseContentTermWeeks && this.props.courseContentTermWeeks) {
            if (this.props.courseContentTermWeeks.length > 1) {
                this.setState({ weeklyTerm: true })

            }
            else if (this.props.courseContentTermWeeks.length === 1) {
                this.setState({ nonWeeklyCourse: true })

            }
        }

        if (this.state.weeklyTerm !== prevState.weeklyTerm && this.state.weeklyTerm && this.props.courseDefaultView === CourseDefaultViewType.List) {
            this.onFilter(null);
        }

        if (this.props.courseDefaultView !== prevProps.courseDefaultView && this.state.weeklyTerm && this.props.courseDefaultView === CourseDefaultViewType.List && !this.props.loaded) {
            this.onFilter(null);
        }
    }

    activitiesScrollToTop = () => {
        let activities = document.getElementById("spinnerIdWeekA_Content");
        if (activities) {
            activities.scrollIntoView({
                block: 'start',
                behavior: "smooth"
            });
        }

    }

    public getActivitiesCallback = () => {
        this.props.dispatch(Actions.getActivityIdsByWeeks(this.props.coursePageClassId!, '', false, 'getActivityIdsByWeeks', 'get', undefined, false, this.props.coursePageActivityId ?? ""))
        this.activitiesScrollToTop();
    }

    getWeekOrUnitId = () => {
        if (this.props.weekOrUnitId === '0') {
            return '-1';
        }
        else {
            return this.props.weekOrUnitId;
        }
    }

    getOnlyPassiveList = () => {
        if (this.state.filters.GetOnlyPassiveList) {
            return this.state.filters.GetOnlyPassiveList;
        }
        else {
            return false;
        }
    }

    getHasFilter = () => {
        if (this.state.filters && (this.state.filters.searchedText || (this.state.filters?.selectedActivityTypes?.length))) {
            return true;
        }
        else {
            return false;
        }
    }

    dispatchActivities = () => {
        if (this.props.coursePageClassId && this.props.coursePageActivityId) {

            const _filters = this.state.filters;

            if ((this.props.courseDefaultView === CourseDefaultViewType.List && this.state.weeklyTerm) || (this.state.filters && (this.state.filters.searchedText || (this.state.filters?.selectedActivityTypes?.length)))) {
                _filters.hasFilter = this.getHasFilter();
                _filters.sort = this.props.sort!;
                this.setState({ filters: _filters, isLoading: false });
                const param: IActivityCard = {
                    actId: '',
                    coursePageClassId: this.props.coursePageClassId,
                    coursePageActivityId: this.props.coursePageActivityId,
                    courseContentTermWeeks: this.props.courseContentTermWeeks,
                    hasFilter: _filters.hasFilter,
                    activityFilters: _filters,
                    GetOnlyPassiveList: this.getOnlyPassiveList(),
                    weekOrUnitId: '-1',
                    courseContentMenuType: this.props.courseContentMenuType,
                    sort: this.props.sort!,
                    activeStatus: this.state.statusFilter,
                    courseContentWeekActivities: this.props.courseContentWeeksActivities
                };
                this.props.dispatch(Actions.SetTriggerGetActivities(param, this.activitiesScrollToTop(), "SetTriggerGetActivities", 'get', this.props.courseDefaultView));

            } else {

                _filters.hasFilter = false;
                _filters.sort = this.props.sort!;
                this.setState({ filters: _filters, isLoading: false });
                const param: IActivityCard = {
                    actId: '',
                    coursePageClassId: this.props.coursePageClassId,
                    coursePageActivityId: this.props.coursePageActivityId,
                    courseContentTermWeeks: this.props.courseContentTermWeeks,
                    hasFilter: _filters.hasFilter,
                    activityFilters: _filters,
                    GetOnlyPassiveList: this.getOnlyPassiveList(),
                    weekOrUnitId: this.getWeekOrUnitId(),
                    courseContentMenuType: this.props.courseContentMenuType,
                    courseContentWeekActivities: this.props.courseContentWeeksActivities,
                    sort: this.props.sort!
                };

                this.props.dispatch(Actions.SetTriggerGetActivities(param, this.getActivitiesCallback, "SetTriggerGetActivities", 'get', this.props.courseDefaultView, this.state.nonWeeklyCourse));

                this.props.dispatch(Actions.getCourseContentsWeekActivitiesAction(
                    this.props.coursePageClassId,
                    this.props.coursePageActivityId,
                    false,
                    0,
                    1000,
                    this.props.weekOrUnitId === '0' ? '-1' : this.props.weekOrUnitId!,
                    false,
                    false,
                    null,
                    'contentWeekActivities',
                    'get',
                    false,
                    this.props.sort!));
            }
        }
    }

    onFilter = (_filter: any) => {


        if (_filter == null) {
            _filter = this.state.filters
        }

        let filterStatus = false;

        if (_filter.searchedText != "" || _filter.selectedActivityTypes.length > 0) {
            filterStatus = true;
        }
        const param: IActivityCard = {
            actId: '',
            coursePageClassId: this.props.coursePageClassId,
            coursePageActivityId: this.props.coursePageActivityId,
            courseContentTermWeeks: this.props.courseContentTermWeeks,
            hasFilter: filterStatus,
            activityFilters: _filter,
            GetOnlyPassiveList: this.getOnlyPassiveList(),
            weekOrUnitId: '-1',
            courseContentMenuType: this.props.courseContentMenuType,
            sort: this.props.sort!,
            activeStatus: this.state.statusFilter,
            courseContentWeekActivities: this.props.courseContentWeeksActivities
        };

        this.callFilterApi(param);
    };
    callFilterApi = (param: any) => {
        this.props.dispatch(Actions.SetTriggerGetActivities(param, this.activitiesScrollToTop(), "SetTriggerGetActivities", "get", CourseDefaultViewType.List));

    }

    inputOnChange = (e: any) => {
        if (e?.target) {
            let _filters = this.state.filters;
            _filters.searchedText = e.target.value;

            this.setState(prevstate => ({ filters: _filters }));


            if (Object.keys(this.props.filterData).length > 0) {
                _filters = this.props.filterData.filter;
                _filters.searchedText = e.target.value;
            }
            this.setFilter({ filter: _filters });

            if (this.delayTimer) {
                clearTimeout(this.delayTimer);
                this.delayTimer = setTimeout(() => this.onFilter(null), 2000);
            }
            else {
                this.delayTimer = setTimeout(() => this.onFilter(null), 2000);
            }



        }

    };

    onClickFilter = (event: any, type: ActivityTypeEnums) => {
        if (event?.target) {
            ReactGA.event({
                category: window.location.host,
                action: 'G_FILTER_CLICKED',
                label: 'G_FILTER_CLICKED',
                nonInteraction: true,
            });
            let _filter = this.state.filters;


            if (Object.keys(this.props.filterData).length > 0) {
                _filter = this.props.filterData.filter;
            }

            const _filterIndex = _filter.selectedActivityTypes.indexOf(type);

            if (event.target.checked && _filterIndex === -1) {
                _filter.selectedActivityTypes.push(type);
            } else if (!event.target.checked && _filterIndex !== -1) {
                _filter.selectedActivityTypes.splice(_filterIndex, 1);
            }

            this.setFilter({ filter: _filter });
            this.setState(prevstate => ({ filters: _filter }));

            this.onFilter(_filter);

            this.setState({ isCheckboxDisabled: true });

            if (this.delayTimerCheckbox) {
                clearTimeout(this.delayTimerCheckbox);
                this.delayTimerCheckbox = setTimeout(() => this.enableCheckbox(), 2000);
            }
            else {
                this.delayTimerCheckbox = setTimeout(() => this.enableCheckbox(), 2000);
            }

        }
    };

    enableCheckbox = () => {
        this.setState({ isCheckboxDisabled: false });
    }

    onSorting = (data: any) => {
        if (data?.value && this.props.sort !== data.value) {
            this.props.dispatch(Actions.SetActivitiesSorting(data.value));

            this.setState((prevState) => ({
                filters: {
                    ...prevState.filters,
                    sort: data.value
                }
            }), () => {
                this.onFilter(null);
            });
        }
    }

    setClose = (refresh: boolean = false) => {
        this.props.onClose(refresh);
    };

    setFilter = (data: any) => {

        let hasFilterStatus = false;

        if (data.filter.searchedText != '' || data.filter.selectedActivityTypes.length > 0) {
            hasFilterStatus = true;
        }

        data.filter.hasFilter = hasFilterStatus;

        this.props.updateFilterData(data);
    };




    checkFilter = (activityType: number) => {

        let response = false;
        if (this.props.filterData.filter) {
            if (this.props.filterData.filter.selectedActivityTypes) {

                if (this.props.filterData.filter.selectedActivityTypes.indexOf(activityType) !== -1) {
                    response = true;
                }
            }
        }




        return response;

    }

    render() {

        if (this.state.redirectMessagesPage) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/Message/Index/?userId=' + this.state.selectedTeacherId} />
        }
        return (
            <Modal
                isOpen={true}
                modalClassName={'add-activity-modal modal-from-right slideInRight show animated filter_modal'}
                fade={true}
                style={{ display: 'block', animationDuration: '0.5s', padding: "0px!important" }}

            >
                <div className="modal-dialog" style={{ width: '27vw' }}>
                    <div className="modal-content">
                        <div className="modal-header d-flex justify-content-start">
                            <div>
                                <h5 className="modal-title d-flex align-items-center">
                                    {T.t('r_gen_activity_filter')}
                                </h5>
                            </div>
                            <div>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onMouseDown={event => this.setClose(false)}
                                >
                                    <i style={{ color: '#000' }} className="material-icons">
                                        close
                                    </i>
                                    <span>{T.t('r_gen_close')}</span>
                                </button>
                            </div>
                        </div>
                        <div className='activity-filter'>
                            {(this.props.courseContentMenuType === CourseContentMenuType.weekAndActivity || this.props.courseContentMenuType === CourseContentMenuType.weekAndActivityStory || this.props.courseContentMenuType === CourseContentMenuType.week) && (

                                <div className="white-box"
                                    style={{ marginBottom: '1em', width: '100%', backgroundColor: 'inherit' }}>
                                    <div className="form-group white-box-body" style={{ minHeight: 0, minWidth: 0, marginBottom: 0, overflowY: 'visible', padding: '10px', paddingTop: '0px !important', marginTop: '2px' }}>

                                        <SelectNoneAsync
                                            name={'selectShorting'}
                                            setSelectValue={[this.props.sort!]}
                                            setOptions={[
                                                { value: 'name', label: T.t('r_activity_filter_sort_name') },
                                                { value: '-', label: T.t('r_activity_filter_sort_createdDate') },
                                                { value: 'startDate', label: T.t('r_activity_filter_sort_startDate') },
                                            ]}
                                            onChange={this.onSorting}
                                            placeHolder={T.t('r_make_select')} />


                                    </div>
                                </div>
                            )}
                            <div className="white-box" style={{ backgroundColor: 'inherit', marginBottom: '23px' }}>
                                {/* <div className="white-box-header">
                        <div>
                            <h2>{T.t('r_activity_filter_search')}</h2>
                        </div>
                    </div> */}
                                <div className="white-box-body form-input form-group" style={{ minHeight: 0, minWidth: 0, paddingTop: 0, overflowY: 'unset' }}>
                                    <div className="input-icon-right"><i className="material-icons mr-3">search</i></div>
                                    <input style={{ width: '100%' }} onChange={this.inputOnChange} type="text" id="activity-filter-searchbar" name="activity-filter-searchbar" required={true} value={this.props.filterData?.filter?.searchedText} />
                                    <span className="highlight" />
                                    <span className="bar" />
                                    <label className='white-box-label' htmlFor="activity-filter-searchbar" >{T.t('r_activity_filter_search')}</label>
                                </div>
                            </div>
                            <div className="white-box mt-4 mb-0" style={{ backgroundColor: 'inherit' }}>
                                <div className="white-box-header" style={{ paddingTop: 0, paddingBottom: 0 }}>
                                    <h2 style={{ borderBottom: '1px solid #bfbeba' }}> {T.t('r_activity_filter')} </h2>
                                </div>

                                <div className="white-box-body" style={{ maxHeight: '100%', overflowY: 'hidden', minHeight: '100%', paddingTop: 0 }}>
                                    <div className="filter-checkboxes">

                                        <label className="filter_control control--checkbox">
                                            {T.t('r_activity_type_Survey')}
                                            <input
                                                type="checkbox"
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onChange={e => this.onClickFilter(e, ActivityTypeEnums.Survey)}
                                                checked={this.checkFilter(ActivityTypeEnums.Survey)}
                                                disabled={this.state.isCheckboxDisabled}
                                            />
                                            <div className="filter_control__indicator" />
                                        </label>
                                        <label className="filter_control control--checkbox">
                                            {T.t('r_activity_type_InformationNote')}
                                            <input
                                                type="checkbox"
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onChange={e => this.onClickFilter(e, ActivityTypeEnums.InformationNote)}
                                                checked={this.checkFilter(ActivityTypeEnums.InformationNote)}
                                                disabled={this.state.isCheckboxDisabled}

                                            />
                                            <div className="filter_control__indicator" />
                                        </label>
                                        <label className="filter_control control--checkbox">
                                            {T.t('r_activity_type_Document')}
                                            <input
                                                type="checkbox"
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onChange={e => this.onClickFilter(e, ActivityTypeEnums.Document)}
                                                checked={this.checkFilter(ActivityTypeEnums.Document)}
                                                disabled={this.state.isCheckboxDisabled}

                                            />
                                            <div className="filter_control__indicator" />
                                        </label>
                                        <label className="filter_control control--checkbox">
                                            {T.t('r_activity_type_Elesson')}
                                            <input
                                                type="checkbox"
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onChange={e => this.onClickFilter(e, ActivityTypeEnums.Elesson)}
                                                checked={this.checkFilter(ActivityTypeEnums.Elesson)}
                                                disabled={this.state.isCheckboxDisabled}

                                            />
                                            <div className="filter_control__indicator" />
                                        </label>
                                        <label className="filter_control control--checkbox">
                                            {T.t('r_activity_type_Forum')}
                                            <input
                                                type="checkbox"
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onChange={e => this.onClickFilter(e, ActivityTypeEnums.Forum)}
                                                checked={this.checkFilter(ActivityTypeEnums.Forum)}
                                                disabled={this.state.isCheckboxDisabled}

                                            />
                                            <div className="filter_control__indicator" />
                                        </label>
                                        <label className="filter_control control--checkbox">
                                            {T.t('r_activity_type_LinkActivity')}
                                            <input
                                                type="checkbox"
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onChange={e => this.onClickFilter(e, ActivityTypeEnums.LinkActivity)}
                                                checked={this.checkFilter(ActivityTypeEnums.LinkActivity)}
                                                disabled={this.state.isCheckboxDisabled}

                                            />
                                            <div className="filter_control__indicator" />
                                        </label>
                                        <label className="filter_control control--checkbox">
                                            {T.t('r_activity_type_LTIActivity')}
                                            <input
                                                type="checkbox"
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onChange={e => this.onClickFilter(e, ActivityTypeEnums.LTIActivity)}
                                                checked={this.checkFilter(ActivityTypeEnums.LTIActivity)}
                                                disabled={this.state.isCheckboxDisabled}

                                            />
                                            <div className="filter_control__indicator" />
                                        </label>
                                        <label className="filter_control control--checkbox">
                                            {T.t('r_activity_type_Assignment')}
                                            <input
                                                type="checkbox"
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onChange={e => this.onClickFilter(e, ActivityTypeEnums.Assignment)}
                                                checked={this.checkFilter(ActivityTypeEnums.Assignment)}
                                                disabled={this.state.isCheckboxDisabled}

                                            />
                                            <div className="filter_control__indicator" />
                                        </label>
                                        <label className="filter_control control--checkbox">
                                            {T.t('r_activity_type_VirtualClass')}
                                            <input
                                                type="checkbox"
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onChange={e => this.onClickFilter(e, ActivityTypeEnums.VirtualClass)}
                                                checked={this.checkFilter(ActivityTypeEnums.VirtualClass)}
                                                disabled={this.state.isCheckboxDisabled}

                                            />
                                            <div className="filter_control__indicator" />
                                        </label>
                                        <label className="filter_control control--checkbox">
                                            {T.t('r_activity_type_Exam')}
                                            <input
                                                type="checkbox"
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onChange={e => this.onClickFilter(e, ActivityTypeEnums.Exam)}
                                                checked={this.checkFilter(ActivityTypeEnums.Exam)}
                                                disabled={this.state.isCheckboxDisabled}

                                            />
                                            <div className="filter_control__indicator" />
                                        </label>

                                        <label className="filter_control control--checkbox">
                                            {T.t('r_activity_type_Video')}
                                            <input
                                                type="checkbox"
                                                // tslint:disable-next-line: jsx-no-lambda
                                                onChange={e => this.onClickFilter(e, ActivityTypeEnums.Video)}
                                                checked={this.checkFilter(ActivityTypeEnums.Video)}
                                                disabled={this.state.isCheckboxDisabled}

                                            />
                                            <div className="filter_control__indicator" />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Modal>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IActivityFiltersProps) => {
    if (!state) {
        return ownProps;
    }

    const newProps = {
        ...ownProps, coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId,
        activityIdAfterAdd: state.coursePage.activityIdAfterAdd,
        courseContentMenuType: state.coursePage.courseContentMenuType,
        courseContentTermWeeks: state.coursePage.courseContentTermWeeks,
        courseContentWeeksActivities: state.coursePage.courseContentWeekActivities,
        coursePageClassInformation: state.coursePage.coursePageclassInformation,
        sort: state.coursePage.courseSortingKey,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        courseFilterActivities: state.coursePage.courseContentWeekActivities,
        courseDefaultView: state.coursePage.courseDefaultView
    };

    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.activityIdAfterAdd === prev.coursePage.activityIdAfterAdd &&
        next.coursePage.courseContentMenuType === prev.coursePage.courseContentMenuType &&
        next.coursePage.courseSortingKey === prev.coursePage.courseSortingKey &&
        next.coursePage.courseContentWeekActivities === prev.coursePage.courseContentWeekActivities &&
        next.coursePage.activityCard === prev.coursePage.activityCard &&
        next.coursePage.courseDefaultView === prev.coursePage.courseDefaultView
    );
    return ret;
};

const CFilterModal = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(FilterModal);

export default CFilterModal;
